<template>
  <div
    class="confirm-container"
    :class="{'active': active}"
    v-if="showItem"
  >
    <div class="confirm">
      <div class="confirm-header">
        <div class="header">
          <slot name="confirm-header" />
        </div>
        <div
          class="confirm-close"
          @click="close"
        >
          <img :src="`${$root.cdnUrl}assets/icon-close.svg`">
        </div>
      </div>
      <div class="confirm-body">
        <slot name="confirm-body" />
      </div>
      <div class="confirm-footer">
        <slot name="confirm-footer" />
      </div>
    </div>
    <div
      class="confirm-outside"
      @click="close"
    />
  </div>
</template>
<script>
export default {
  name: 'Confirm',
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      showItem: false,
      active: false,
      activeCloseBtn: false,
    };
  },
  methods: {
    close () {
      this.$emit('close');
    },
    showConfirm () {
      this.showItem = true;
      document.body.style.overflow = 'hidden';

      setTimeout(() => { this.active = true; }, 250);
      setTimeout(() => { this.activeCloseBtn = true; }, 500);
    },
    hideConfirm () {
      this.activeCloseBtn = false;
      document.body.style.overflow = '';
      setTimeout(() => { this.active = false; }, 250);
      setTimeout(() => { this.showItem = false; }, 750);
    },
  },
  watch: {
    show () {
      if (this.show) {
        this.showConfirm();
      } else {
        this.hideConfirm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirm-container {
    z-index: 1;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition: all ease .1s;

    &:before {
      content: '';
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      background-color: rgba(39, 49, 66, .5);
      opacity: 0;
      transition: opacity ease 1s;
    }

    .confirm-outside {
      position: fixed;
      z-index: 2;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .confirm {
      position: fixed;
      z-index: 3;
      top: 50%;
      left: 20px;
      right: 20px;
      padding: 20px;
      background-color: #fff;
      border-radius: 6px;
      transition: transform ease .5s;
      transform: translateY(100%);
      max-height: 80%;
      overflow: hidden;
      overflow-y: auto;

      .confirm-header{
        .header {
          display: inline-block;
          font-size: 16px;
          color: #273142;
          font-weight: 500;
          margin-bottom: 15px;
        }
        .confirm-close {
          float: right;
        }
      }

      @media screen and (max-height: 550px) {
        top: 50px;
        bottom: 50px;
        .confirm-body {
          overflow-y: auto;
        }
        .confirm-footer {
          background-color: #ffffff;
        }
      }
    }

    &.active {
      &:before {
        opacity: 1;
      }

      .confirm {
        transform: translateY(-50%);
        @media screen and (max-height: 550px) {
          transform: translateY(0);
        }
      }
    }
  }
</style>
